import React, { Component } from 'react';

export class ImplementNav extends Component {
    displayName = ImplementNav.name;

    constructor(props) {
        super(props);
    }

    render() {
        // Implement is the final step. Sharing moved out of the flow in
        // issue #71 Phase 1, so there is no step 4 to advance to.
        if (this.props.implementRecap !== true) {
            return (
                <div className="g-footer__navigation">
                    <div className="g-footer__previous">
                        <a href="#" className="b-btn b-btn--large b-btn--secondary" onClick={this.props.previous}><img src="/images/icon-arrow-left-black.svg" className="b-btn__icon" alt="Previous" /><em>Previous step:</em>&nbsp;<strong>Add/Get License Key</strong></a>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}